export const favoritesLeftNavItemId = 'favorites';
export const deletedItemsLeftNavItemId = 'deletedItems';
export const contactsLeftNavItemId = 'contacts';
export const contactListsLeftNavItemId = 'contactLists';
export const joinedUnifiedGroupsLeftNavId = 'joinedUnifiedGroups';
export const ownedUnifiedGroupsLeftNavId = 'ownedUnifiedGroups';
export const deletedUnifiedGroupsLeftNavId = 'deletedUnifiedGroups';

export function isContactsOrContactListsLeftNavItem(activeItemId: string): boolean {
    return activeItemId === contactsLeftNavItemId || activeItemId === contactListsLeftNavItemId;
}

export function isContactsLeftNavItem(activeItemId: string) {
    return activeItemId === contactsLeftNavItemId;
}

export function isContactListsLeftNavItem(activeItemId: string) {
    return activeItemId === contactListsLeftNavItemId;
}
